import { Button, Form, Input, Spin } from 'antd'
import styles from './../../Login/Login.module.scss'
import { useNavigate } from 'react-router-dom'
import {useDispatch, useSelector} from 'react-redux'
import {AppDispatch, RootState} from '../../../../app/store'
import notificationHandler from '../../../atoms/Notification'
import logo from '../../../../assets/images/logo.png'
import { getLoginSSO, setPhoneNumber, setUsers } from './slice'
import jwt_decode from "jwt-decode";
import React from 'react'
import { LoadingOutlined } from '@ant-design/icons'
import './../../../atoms/loading.scss'

const LoginSSO = () => {
  const navigate = useNavigate()
  const dispatch = useDispatch<AppDispatch>()
  const [loading, setLoading] = React.useState(false);

  const antIcon = <LoadingOutlined style={{ fontSize: 70 ,position: 'fixed' }} spin />;

  const onFinish = (values: any) => {
    setLoading(true);
    if (values) {
      dispatch(getLoginSSO({ username: values.username, password: values.password })).unwrap().then((res: any) => {
        console.log(res)
          if (res.success === true) {
            notificationHandler('success', 'Đăng nhập tài khoản thành công!')
            dispatch(setPhoneNumber(res.data.payload.phone))
            setLoading(false);
            navigate("/order-meals");
          } else {
            notificationHandler('error', res.response.data.data.msg_content)
            setLoading(false);
          }
        }).catch((error) => {
          console.log(error)
          notificationHandler('error', error.response.data.data.msg_content);
          setLoading(false);
        })
    }
  }

  return (
   <>
    <div className={styles.login_page}>
    <div>
    <Spin indicator={antIcon} spinning={loading} />
      <div className={styles.login_box}>
        <Form
          name={styles.login_form}
          initialValues={{ remember: true }}
          onFinish={onFinish}
        >
          <img src={logo} alt="Logo" className='mx-auto' />
          <p className='text-center text-[18px]'>SSO</p>
          <Form.Item
            name="username"
            rules={[{ required: true, message: 'Nhập tài khoản!' }]}
          >
            <Input placeholder="Tài khoản " onBlur={(e) => e.target.value = e.target.value.trim()} maxLength={200} />
          </Form.Item>

          <Form.Item
            name="password"
            rules={[{ required: true, message: 'Nhập mật khẩu!' }]}
          >
            <Input.Password placeholder="Mật khẩu"onBlur={(e) => e.target.value = e.target.value.trim()} maxLength={50} />
          </Form.Item>

          <Form.Item>
            <Button
              htmlType="submit"
              loading={loading}
              className="login-form-button text-white p-[5px_20px] bg-primary hover:border-primary hover:text-primary mx-auto mt-3 w-full"
            >
              Đăng Nhập
            </Button>
          </Form.Item>
        </Form>
      </div>
    </div>
    </div>
   </>
  )
}

export default LoginSSO
